export default "__VITE_ASSET__C3GF3wQn__"